import * as Colors from './colors'
import * as Typography from './typography'

export default {
  Colors,
  Typography,
}
